"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_redux_1 = require("react-redux");
const react_native_paper_1 = require("react-native-paper");
const react_2 = require("redux-persist/integration/react");
const react_native_safe_area_context_1 = require("react-native-safe-area-context");
const react_native_1 = require("react-native");
const store_1 = require("./store");
const appNavigator_1 = __importDefault(require("./appNavigation/appNavigator"));
const theme_1 = __importDefault(require("./styles/theme"));
const constants_1 = require("./constants/constants");
const analytics_1 = require("./utils/analytics/analytics");
require("./utils/i18n/i18n");
const theme = {
    ...react_native_paper_1.DefaultTheme,
    colors: {
        ...react_native_paper_1.DefaultTheme.colors,
        primary: theme_1.default.colors.COLOR_PRIMARY,
        accent: theme_1.default.colors.COLOR_SECONDARY,
        placeholder: theme_1.default.colors.COLOR_BLACK_6,
        background: theme_1.default.colors.COLOR_WHITE,
    },
    fonts: (0, react_native_paper_1.configureFonts)(constants_1.FONT_CONFIG),
};
const App = () => {
    const { height } = react_native_1.Dimensions.get('window');
    return (react_1.default.createElement(react_native_safe_area_context_1.SafeAreaProvider, null,
        react_1.default.createElement(react_redux_1.Provider, { store: store_1.store },
            react_1.default.createElement(react_2.PersistGate, { persistor: store_1.persistor },
                react_1.default.createElement(analytics_1.AnalyticsProvider, null,
                    react_1.default.createElement(react_native_paper_1.Provider, { theme: theme },
                        react_1.default.createElement(react_native_safe_area_context_1.SafeAreaView, { style: { minHeight: height }, edges: ['top', 'left', 'right', 'bottom'] },
                            react_1.default.createElement(react_native_1.View, { style: { flex: 1 } },
                                react_1.default.createElement(appNavigator_1.default, null)))))))));
};
exports.default = App;
